import React from "react";
import { getCodeFolder, getCodeFolders, getCodeFolderSave } from "../../actions/folder";
import { connect } from "react-redux";
import { faArrowLeft, faBars, faCheck } from "@fortawesome/free-solid-svg-icons";
import { getIdInUrl, tempAlWait } from "../../helpers";
import AdminHeader from "../../components/AdminHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminHaut from "../../components/AdminHaut";
import AdminItemFolder from "../../components/AdminItemFolder";

class AdminFolders extends React.Component {
    state = {
        menuActive: false,
        alert: {
            acitve: false,
            type: '',
            title: '',
            desc: ''
        },
        opts: [{
            type: 'link',
            ttl: "Retourner à la liste des projets",
            ico: faArrowLeft,
            link: "/admin/projects",
            action: null,
            col: null
        }],
        formName: '',
        activeModal: false,
        activeFolder: null,
        datas: [],
        id: null
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none";
        })
        document.getElementById('page').classList.add('pageWithout');

        if (this.props.canContinue) {
            this.setState({id: getIdInUrl()});
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.id != prevState.id) {
            this.props.getCodeFolders({ idProject: this.state.id });
            this.setState({
                alert: tempAlWait()
            })
        }

        if (this.props.redCdFldList != prevProps.redCdFldList) {
            this.setState({
                alert: this.props.redCdFldList.alert,
                datas: this.props.redCdFldList.datas
            })
        }

        if (this.props.redCdFldSave != prevProps.redCdFldSave) {
            this.setState({
                alert: this.props.redCdFldSave.alert,
            })
            if (this.props.redCdFldSave.isNext) {
                this.props.getCodeFolders({idProject: this.state.id});
            }
        }
    }

    handleSave(el, id = null) {
        el.preventDefault();
        this.setState({
            alert: tempAlWait()
        })
        this.props.getCodeFolderSave({
            idFolder: null,
            idFolderAdult: id,
            idProject: this.state.id,
            name: this.state.formName
        })
    }

    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                active={this.state.menuActive}
                changeAlert={(el) => this.setState({alert: el})}
                idtt={this.props.idtt}
            />

            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut
                ttl="Code - Les dossiers"
                options={this.state.opts}
            />

            {/** Données de la page **/}
            <div className="admin__ctnr">
                {
                    this.state.datas.length == 0 ?
                        <ul className="admin__listfldr">
                            <h2 className="admin__empty">Aucun dossier n'a été créé pour le moment.</h2>
                            <div className="admin__item__formline">
                                <input
                                    type={this.state.formName}
                                    onChange={(el) => this.setState({formName: el.target.value})}
                                    className="admin__item__inputline"
                                    title="Nom du dossier"
                                    aria-label="Nom du dossier"
                                    placeholder="Nom du dossier"
                                />
                                <button
                                    title="Enregistrer le dossier"
                                    aria-label="Enregistrer le dossier"
                                    className="admin__item__eyebtn"
                                    onClick={(el) => this.handleSave(el)}
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </button>
                            </div>
                        </ul> :
                        <ul className="admin__listfldr">
                            {
                                this.state.datas
                                    .sort((a, b) => {
                                        if (a.name < b.name) {
                                            return -1;
                                        } else {
                                            return 1;
                                        }
                                    })
                                    .map((data, key) => {
                                    return <AdminItemFolder
                                        data={data}
                                        key={`folder-${key}`}
                                        changeAlert={(alert) => {this.setState({alert: alert})}}
                                        refreshList={(doRefresh) => {
                                            if (doRefresh) {
                                                this.props.getCodeFolders({idProject: this.state.id})
                                            }
                                        }}
                                        idFolderAdult={null}
                                    />
                                })
                            }
                            <div className="admin__item__formline">
                                <input
                                    type={this.state.formName}
                                    onChange={(el) => this.setState({formName: el.target.value})}
                                    className="admin__item__inputline"
                                    title="Nom du dossier"
                                    aria-label="Nom du dossier"
                                    placeholder="Nom du dossier"
                                />
                                <button
                                    title="Enregistrer le dossier"
                                    aria-label="Enregistrer le dossier"
                                    className="admin__item__eyebtn"
                                    onClick={(el) => this.handleSave(el)}
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </button>
                            </div>
                        </ul>
                }
            </div>
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redCdFldList: state.redCdFldList,
        redCdFldSave: state.redCdFldSave,
    }
}

const mapDispatchToProps = {
    getCodeFolders,
    getCodeFolderSave
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminFolders);